<template>
  <section-collapseable
    v-if="duplicateLeads.length"
    default-expanded
    hide-initial-always
    title="Potential Duplicates"
    second-button-text="Manage"
    @secondButtonClick="openDuplicateLeadsListModal"
    class="duplicate-box"
  >
    <template v-slot:expanded>
      <div v-for="lead in duplicateLeads" :key="lead.record_id" class="duplicate_lead">
        <p class="duplicate_lead--status">{{lead.status_label}}</p>
        <p class="duplicate_lead--address" @click="openRecordModal(lead.record_id)">{{ lead.address }}</p>
      </div>
    </template>
  </section-collapseable>
</template>

<script>
import {defineComponent} from 'vue'
import {appendModal, destroyModal} from "../../../services/modals";
import router from "../../../router";
import DuplicateLeadsListModal from "../../duplicates/DuplicateLeadsListModal.vue";

export default defineComponent({
  name: "LeadDuplicateList",
  props: {
    currentLeadId: {
      type: String | null,
      required: true,
    },
    duplicateLeads: {
      type: Array,
    },
  },
  data() {
    return {
      duplicateLeadsListModal: '',
    }
  },
  mounted() {
    if (this.duplicateLeads.length) {
      this.openDuplicateLeadsListModal()
    }
  },
  watch: {
    duplicateLeads() {
      if (!this.duplicateLeads.length) {
        destroyModal(this.duplicateLeadsListModal)
      }
    },
  },
  computed: {
    isPlural() {
      return this.duplicateLeads.length > 1
    },
  },
  methods: {
    openRecordModal(id) {
      router.replace({query: {lead: id}});
    },
    openDuplicateLeadsListModal() {
      this.duplicateLeadsListModal = appendModal(
        DuplicateLeadsListModal,
        this,
        {
          currentLeadId: this.currentLeadId,
          duplicateLeads: this.duplicateLeads,
        });

      this.duplicateLeadsListModal.$on("reloadList", () => {
        this.$emit('reload')
      })
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.duplicate-box {
  border: 1px solid $danger;
  box-shadow: 0 2px 4px $danger;
}

.duplicate_lead {
  margin-top: 0.5rem;

  &--status {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }

  &--address {
    font-weight: bold;
    color: $link;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }
}
</style>
